import "../styles/report.css";
import { ReportNav } from "../components/report/ReportNav";
import { ReportHero } from "../components/report/ReportHero";
import { ReportBody } from "../components/report/ReportBody";
import { ReportFooter } from "../components/report/ReportFooter";

export default function Report() {
  return (
    <div className="report-root" data-testid="report-page">
      <ReportNav />
      <ReportHero />
      <ReportBody />
      <ReportFooter />
    </div>
  );
}
